import styled from 'styled-components'
import { Button } from '@streamr/streamr-layout'
import { TABLET, SANS, REGULAR, DESKTOP } from '@streamr/streamr-layout/styled'

export const DiveIn = styled.div`
    margin-top: 5rem;
    text-align: center;

    h3 {
        display: none;
    }

    ${Button} {
        border-radius: 8px;
        font-size: 0.875rem;
        min-height: 64px;
    }

    @media (min-width: ${TABLET}px) {
        h3 {
            display: block;
            font-family: ${SANS};
            font-size: 1.625rem;
            font-weight: ${REGULAR};
            line-height: 2rem;
            margin: 0;
            margin-bottom: 3rem;
        }

        ${Button} {
            font-size: 1rem;
            min-height: 56px;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        margin-top: 7.5rem;
    }
`
